/**
 * Copyright (c) 2023 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : index.jsx
 * description   : {{insert here}}
 * creation date : 11/11/2023
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    BrowserRouter,
} from 'react-router-dom';

import {
    Amplify,
} from 'aws-amplify';

import {
    Authenticator,
} from '@aws-amplify/ui-react';

import {
    ComponentContext,
} from '@/components/core';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import awsExports from '@/aws-exports';



// --------------------------------------------------------------------------------
//      STYLE
// --------------------------------------------------------------------------------

import '@/styles/theme/styles.scss';
import '@/styles/app/styles.scss';



// --------------------------------------------------------------------------------
//      MODULE CONFIGURATION
// --------------------------------------------------------------------------------

Amplify.configure(awsExports);



// --------------------------------------------------------------------------------
//      CONSTANTS DEFINITION
// --------------------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));



// --------------------------------------------------------------------------------
//      MAIN RENDER
// --------------------------------------------------------------------------------

root.render(
    <React.StrictMode>
        <Authenticator.Provider>
            <BrowserRouter>
                <ComponentContext>
                    <App />
                </ComponentContext>
            </BrowserRouter>
        </Authenticator.Provider>
    </React.StrictMode>
);



// End of file
